const NotFound404Icon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 935 711'
    className={className}
  >
    <g
      fill='none'
      fillRule='evenodd'
    >
      <path
        d='M257.4 488.35l-49.45 11.415-7.046-30.522-37.854 8.74 7.046 30.522-162.16 37.437L18.409 591.3l194.373 80.31 33.08-7.638-27.439-118.849 49.45-11.416L257.4 488.35zm-76.832 65.512l15.195 65.818-4.092.945-106.998-41.032-.787-3.41 96.682-22.321zM902.596 509.534l-4.423-50.557 31.206-2.73-3.386-38.702-31.206 2.73-14.505-165.792-46.373 4.057L727.33 439.844l2.96 33.821 121.51-10.63 4.423 50.556 46.373-4.057zm-54.182-85.202l-67.293 5.887-.366-4.184 55.524-100.245 3.487-.305 8.648 98.847zM474.44 673.9l26.893-43.038 26.565 16.6 20.588-32.947-26.565-16.6 88.191-141.136-39.476-24.668-194.23 80.655-17.99 28.792 103.44 64.637-26.893 43.038 39.477 24.668zm8.004-100.652l-57.286-35.796 2.226-3.562 104.673-46.644 2.968 1.854-52.581 84.148z'
        fill='#101010'
        fillRule='nonzero'
      ></path>
      <path
        d='M555.051 587.807c10.348 65.336 72.4 94.665 148.452 82.62 75.88-12.019 124.794-58.923 114.446-124.259-10.266-64.817-71.363-94.829-147.242-82.81-76.052 12.045-125.922 59.632-115.656 124.449zm42.52-6.735c-5.776-36.47 28.874-62.688 80.555-70.874 51.508-8.158 91.354 6.261 97.13 42.732 5.94 37.507-27.173 62.242-79.2 70.482-52.026 8.24-92.544-4.832-98.485-42.34zM408.928 487.742c41.63-51.408 21.905-117.147-37.935-165.604-59.705-48.348-127.292-53.313-168.921-1.905-41.3 51-22.72 116.486 36.983 164.833 59.84 48.458 128.574 53.676 169.873 2.676zm-33.456-27.092c-23.237 28.696-65.907 20.49-106.571-12.44-40.528-32.819-56.475-72.079-33.237-100.775 23.898-29.512 64.437-21.455 105.373 11.695 40.936 33.15 58.334 72.008 34.435 101.52z'
        fill='#101010'
        fillRule='nonzero'
      ></path>
      <path
        d='M636.39 466.053c65.145 11.487 113.078-37.636 126.449-113.466 13.34-75.658-15.084-137.178-80.229-148.665-64.628-11.396-112.896 36.602-126.236 112.26-13.371 75.83 15.388 138.475 80.016 149.871zm7.475-42.396c-36.364-6.412-49.873-47.71-40.787-99.24 9.056-51.358 35.662-84.339 72.026-77.927 37.399 6.594 50.005 45.957 40.858 97.831-9.147 51.875-34.699 85.93-72.097 79.336z'
        fill='#101010'
        fillRule='nonzero'
      ></path>
      <path
        fill='#FF600A'
        d='M860.681 234.086l-58.708 60.806L568.81 69.771l58.71-60.806zM535.17 410.584c0 29.594-23.992 53.583-53.584 53.583-29.595 0-53.586-23.989-53.586-53.583C428 380.989 451.991 357 481.586 357c29.592 0 53.584 23.99 53.584 53.584'
      ></path>
    </g>
  </svg>
);

export default NotFound404Icon;
